import { Review } from '../state/types';
import * as S from './styles';
import ThumbsUpIcon from 'common/icons/thumbsUpIcon';
import StarsRating from './StarsRating';
import { CSSProperties } from 'styled-components';
import { ProviderRating } from '../state/types';

interface RatingRecommendedProps {
    provider:string;
    recommended: boolean;
    providers?: ProviderRating[];
    starStyle?: CSSProperties;
    thumbsStyle?: any;
    showEmptyStars?: boolean;
    thumbtext?: boolean;
    rating?: number;
    totalRecommended?: number;
    totalNotRecommended?: number;
    starColor?: string;
}
export const getRatingRecommended = (info: RatingRecommendedProps) => {
    if (info.provider==='FACEBOOK' && info.recommended!==null) {
        let icon = <S.Icon rotationValue={info.recommended ? `rotate(0deg)` : `rotate(180deg)`}>
                        <ThumbsUpIcon width={info.thumbsStyle?.width} height={info.thumbsStyle?.height}/>
                    </S.Icon>;
        if (info.thumbtext) {
            let text: string = info.recommended ? 'Recommended': 'Not Recommended'
            return <S.RecommendedContainer>
                    <S.Recommended> {`${text} (${info.recommended ? info.totalRecommended?.toLocaleString('en-US'): info.totalNotRecommended?.toLocaleString('en-US')})`}</S.Recommended>
                    {icon}
                    </S.RecommendedContainer>;
        } else return icon;
    }

    if (info.provider!=='recommended')  {
        return <StarsRating
                        rating={info.rating??0}
                        starStyle={info.starStyle}
                        showEmptyStars={info.showEmptyStars??false}
                        starColor={info.starColor}
                    />
    }
    
    return '';
}